import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "./ImageGrid.scss"

const ImageGrid = ({ images, onImageClick }) => {
  return (
    <div className="serper-image-grid">
      {images.map((image, index) => (
        <img
          key={image.thumb}
          src={image.thumb}
          alt={`image-${index}`}
          className="serper-image-grid__image"
          onClick={() => onImageClick(image.url)}
        />
      ))}
    </div>
  );
};


ImageGrid.propTypes = {
  imageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  onImageClick: PropTypes.func.isRequired,
};


const searchImages = async (keywords) => {

    if (keywords.length == 0) {
        return []
    }

    const response = await fetch("https://google.serper.dev/images", {
        method: 'POST',
        headers: {
            "X-API-KEY": "a9d04695c23df2fb67e865d4bf870f6de976ac63",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(
            keywords.map(keyword => ({
                q: keyword,
                gl: "ru",
                hl: "ru"
            }))
        )
    });

    const result = await response.json();

    const images = []

    result.forEach(query => {
        query.images.forEach(item=>{
            if (item.imageWidth >= 400 && item.imageHeight >= 400) {
                images.push({url: item.imageUrl, thumb: item.thumbnailUrl});
            }
        })
    });
    return images
}

const ImageGridWrapper = ({ onImageClick, keywords }) => {
  const [imageUrls, setImageUrls] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    searchImages(keywords)
      .then(urls => setImageUrls(urls))
      .catch(error => {
        console.error('Error fetching images:', error);
        setImageUrls([]);
      })
      .finally(() => setLoading(false));
  }, [keywords]);

  if (keywords.length === 0) {
    return null;
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return <ImageGrid images={imageUrls} onImageClick={onImageClick} />;
};

ImageGridWrapper.propTypes = {
  onImageClick: PropTypes.func.isRequired,
};



export default ImageGridWrapper;
